import React, { useState, useEffect ,useRef,useLayoutEffect } from "react";

import { Row, Col, Input, Select, Form, Upload, message, Button ,Spin} from "antd";
import { Margin } from "styled-components-spacing";
import Center from "react-center";
import { UploadOutlined } from "@ant-design/icons";
import { API_URL } from "../../../../constants";
import useAxios from "@use-hooks/axios";
import isEmail from "validator/lib/isEmail";
// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/ContactUs/Festival/Festival.css";

const { Option } = Select;
const { TextArea } = Input;
const contactInput = {
  textAlign: "right",
  direction: "rtl",
  paddingRight: "30px",
  fontFamily: "IranSans",
  fontSize: ".9em",
  borderRadius: "15px",
};
const contactInputTablet = {
  textAlign: "right",
  direction: "rtl",
  paddingRight: "30px",
  fontFamily: "IranSans",
  fontSize: ".85em",
  borderRadius: "15px",
};
const contactInputMobile = {
  textAlign: "center",
  direction: "rtl",
  fontFamily: "IranSans",
  fontSize: ".8em",
  borderRadius: "15px",
};
const contactSelect = {
  width: "100%",
  fontFamily: "IranSans",
  color: "rgb(122, 121, 121)",
  borderColor: "#333",
  textAlign: "center",
};
const contactSelectMobile = {
  width: "100%",
  fontFamily: "IranSans",
  color: "rgb(122, 121, 121)",
  borderColor: "#333",
  textAlign: "center",
  fontSize: ".8em",
};
const contactTextArea = {
  fontFamily: "IranSans",
  color: "#333",
  direction: "rtl",
  textAlign: "right",
  borderRadius: "15px",
};
function handleChange(value) {
  console.log(`selected ${value}`);
}

const FestivalMain = (props) => {
  const [form] = Form.useForm();
  const [postvalues, setPostValues] = useState();
  const [fileList, setFileList] = useState([]);
  const [loading, setLoading] = useState(false);

  const postFestival = useAxios({
    url: `${API_URL}/Festival_Service/`,
    method: "POST",
    options: {
      data: postvalues,
    },
    trigger: postvalues,

    forceDispatchEffect: () => !!postvalues,
    customHandler: (err, res) => {
      if (res) {
        console.log("rest", res);
        message.success("ذخیره اطلاعات");
        setLoading(false);

        form.resetFields();
      }
    },
  });

  const firstUpdate = useRef(true);
  useLayoutEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    console.log("here");

    setLoading(true);
  }, [postvalues]);
  useEffect(() => {
    setFileList([]);
  }, [postvalues]);

  const handleupload = (file, List) => {
    setFileList(List);
  };

  const onFinish = (values) => {
    console.log(values);
    const formData = new FormData();
    if (isEmail(values.email)) {
      if (values.phone.length == 11) {
        if (fileList.length > 0) {
          formData.append("first_and_last_name", values.name);
          formData.append("email", values.email);
          formData.append("code", values.code);
          formData.append("phone_number", values.phone);
          formData.append("provience", values.provience);
          formData.append("degree", values.degree);
          formData.append("address", values.address);
          formData.append("field", values.field);
          formData.append("file", fileList[0], fileList[0].name);
          formData.append("birth_date", values.birth_date);
          setPostValues(formData);
        } else {
          message.error("افزودن فایل");
        }
      } else {
        message.error("شماره موبایل معتبر نیست");
      }
    } else {
      message.error("پست الکترونیک را وارد نمایید");
    }
    // if (!isGetDate) {
    //   console.log(moment().locale("en").format("YYYY-MM-DD"));
    //   formData.append("date", moment().locale("en").format("YYYY-MM-DD"));
    // } else {
    //   console.log(date);
    //   formData.append("date", date);
    // }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const isNumeric = (rule, value) => {
    if (!isNaN(value)) return Promise.resolve();

    return Promise.reject("لطفا عدد وارد نمایید");
  };
  return props.size === "laptopdesktop" ? (
    <div className="FestivalBackground">
      <div style={{ paddingTop: "100px" }}>
        <Center>
          <p className="mainTitle mainTitleBorderRight mainTitleBorderLeft">
            <strong>جشنواره پایان نامه ای</strong>
          </p>
        </Center>
      </div>
      <Spin spinning={loading}>

      <Form
        onFinish={onFinish}
        initialValues={{ degree: "0" }}
        form={form}
        onFinishFailed={onFinishFailed}
      >
        <Row style={{ marginTop: "150px" }}>
          <Col span={5}></Col>
          <Col span={14}>
            <div
              style={{
                opacity: "95%",
                backgroundColor: "#fff",
                borderRadius: "20px",
                boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                padding: "25px",
              }}
            >
              <p className="textParagraph">
                شرکت ایرانیان پوشش در راستای حمایت از اندیشه های خلاق ، نیروهای
                جوان و نخبگان ، هر سال اقدام به برگزاری{" "}
                <span
                  style={{
                    fontSize: ".9em",
                    color: "#4983C4",
                    fontFamily: "IranSans",
                  }}
                >
                  <strong>جشنواره انتخاب پایان نامه برتر در حوزه بیمه</strong>
                </span>{" "}
                می کند. این جشنواره در{" "}
                <span
                  style={{
                    fontSize: ".9em",
                    color: "#4983C4",
                    fontFamily: "IranSans",
                  }}
                >
                  <strong>سیزدهم آذر</strong>
                </span>{" "}
                ، مصادف با سالروز تأسیس این شرکت و روز ملی صنعت بیمه برگزار می
                شود که طی آن پایان نامه های ارائه شده در حوزه های مختلف بیمه ای
                به داوری گذاشته می شوند.
              </p>
              <Row>
                <Col span={24} style={{ direction: "rtl", textAlign: "right" }}>
                  <Row>
                    <p className="textParagraph">
                      <span
                        style={{
                          fontSize: ".9em",
                          color: "#ed1c24",
                          fontFamily: "IranSans",
                        }}
                      >
                        <strong>هدیه</strong>
                      </span>{" "}
                      پایان نامه ی برتر: جایزه نقدی + استخدام در شرکت ایرانیان
                      پوشش
                    </p>
                  </Row>
                  <Row>
                    <p className="textParagraph">
                      <span
                        style={{
                          fontSize: ".9em",
                          color: "#ed1c24",
                          fontFamily: "IranSans",
                        }}
                      >
                        <strong>مهلت ارسال:</strong>
                      </span>{" "}
                      پایان آبان ماه 1399
                    </p>
                  </Row>
                </Col>
              </Row>

              <Margin top={3}></Margin>
              <Row>
                <Col span={8}>
                  <div style={{ margin: "10px" }}>
                    <Form.Item
                      name="phone"
                      rules={[
                        {
                          validator: isNumeric,
                        },
                        {
                          required: true,
                          message: "شماره موبایل را وارد نمایید",
                        },
                      ]}
                    >
                      <Input style={contactInput} placeholder="شماره موبایل" />
                    </Form.Item>
                  </div>
                </Col>
                <Col span={8}>
                  <div style={{ margin: "10px" }}>
                    <Form.Item
                      name="code"
                      rules={[
                        {
                          validator: isNumeric,
                        },
                        {
                          required: true,
                          message: "کد ملی را وارد نمایید",
                        },
                      ]}
                    >
                      <Input style={contactInput} placeholder="کدملی" />
                    </Form.Item>
                  </div>
                </Col>
                <Col span={8}>
                  <div style={{ margin: "10px" }}>
                    <Form.Item
                      name="name"
                      rules={[
                        {
                          required: true,
                          message: "نام و نام خانوادگی را وارد نمایید",
                        },
                      ]}
                    >
                      <Input
                        style={contactInput}
                        placeholder="نام و نام خانوادگی"
                      />
                    </Form.Item>
                  </div>
                </Col>
              </Row>
              <Margin top={3}></Margin>
              <Row>
                <Col span={8}>
                  <div style={{ margin: "10px" }}>
                  <Form.Item
                      name="birth_date"
                      rules={[
                        //     {
                        //       validator: validateEmail,
                        //     },
                        {
                          required: true,
                          message: "تاریخ تولد را وارد نمایید",
                        },
                      ]}
                    >
                    <Input
                      style={contactInput}
                      placeholder="تاریخ تولد ۱۳۹۹/۱۲/۲۴"
                    />
                    </Form.Item>
                  </div>
                </Col>
                <Col span={8}>
                  <div style={{ margin: "10px" }}>
                    <Form.Item
                      name="provience"
                      rules={[
                        {
                          required: true,
                          message: "استان محل سکونت را وارد نمایید",
                        },
                      ]}
                    >
                      <Input
                        style={contactInput}
                        placeholder="استان محل سکونت"
                      />
                    </Form.Item>
                  </div>
                </Col>
                <Col span={8}>
                  <div style={{ margin: "10px" }}>
                    <Form.Item
                      name="email"
                      rules={[
                        {
                          required: true,
                          message: "پست الکترونیک را وارد نمایید",
                        },
                      ]}
                    >
                      <Input style={contactInput} placeholder="پست الکترونیک" />
                    </Form.Item>
                  </div>
                </Col>
              </Row>
              <Margin top={3}></Margin>
              <Row>
                <Col span={24}>
                  <div style={{ margin: "10px" }}>
                    <Form.Item
                      name="address"
                      rules={[
                        {
                          required: true,
                          message: "آدرس محل سکونت را وارد نمایید",
                        },
                      ]}
                    >
                      <TextArea
                        style={contactTextArea}
                        rows={2}
                        placeholder="آدرس محل سکونت"
                      />
                    </Form.Item>
                  </div>
                </Col>
              </Row>
              <Margin top={3}></Margin>
              <Row>
                <Col span={8}>
                  <div style={{ margin: "10px", width: "100%" }}>
                    <Upload
                      fileList={fileList}
                      style={{ width: "100%" }}
                      beforeUpload={handleupload}
                    >
                      <Button style={{ borderRadius: "20px", width: "200px" }}>
                        <p style={contactInput}>
                          آپلود فایل پایان نامه
                          <UploadOutlined />
                        </p>
                      </Button>
                    </Upload>
                  </div>
                </Col>
                <Col span={8}>
                  <div style={{ margin: "10px" }}>
                    <Form.Item
                      name="reshte"
                      rules={[
                        {
                          required: true,
                          message: "رشته تحصیلی را وارد نمایید",
                        },
                      ]}
                    >
                      <Input style={contactInput} placeholder="رشته تحصیلی" />
                    </Form.Item>
                  </div>
                </Col>
                <Col span={8}>
                  <div style={{ margin: "10px" }}>
                    <Form.Item
                      name="degree"
                      rules={[
                        {
                          validator: isNumeric,
                        },
                        {
                          required: true,
                          message: "رشته تحصیلی را انتخاب نمایید",
                        },
                      ]}
                    >
                      <Select
                        className="ant-select ant-select-single ant-select-show-arrow"
                        style={contactSelect}
                        defaultValue="0"
                        onChange={handleChange}
                      >
                        <Option style={contactInput} value="0" disabled>
                          آخرین مدرک تحصیلی
                        </Option>
                        <Option style={contactInput} value="0">
                          کارشناسی
                        </Option>
                        <Option style={contactInput} value="1">
                          کارشناسی ارشد
                        </Option>
                        <Option style={contactInput} value="2">
                          دکترا
                        </Option>
                      </Select>
                    </Form.Item>
                  </div>
                </Col>
              </Row>
              <Margin top={3}></Margin>
              <Row>
                <Col span={18} style={{ direction: "ltr", textAlign: "left" }}>
                  <div style={{ margin: "10px" }}>
                    <Button
                      htmlType="submit"
                      class="introBtn introBtn-white introBtn-animated"
                      style={{
                        fontSize: ".85em", fontFamily: "IRANSans", paddingRight: "20px", paddingLeft: "20px", paddingTop: "1.5px", paddingBottom: "1.5px", backgroundColor: "#186491", color: "#fff", borderRadius: "100px"
                      }}
                      
                    >
                      ارسال
                    </Button>
                  </div>
                </Col>
                <Col span={6}></Col>
              </Row>
            </div>
            <Margin bottom={5}></Margin>
          </Col>
          <Col span={5}></Col>
        </Row>
      </Form>
      </Spin>
    </div>
  ) : props.size === "tablet" ? (
    <div className="FestivalBackground">
      <div style={{ paddingTop: "75px" }}>
        <Center>
          <p className="mainTitleTablet mainTitleBorderRight mainTitleBorderLeft">
            <strong style={{ padding: "15px" }}>جشنواره پایان نامه ای</strong>
          </p>
        </Center>
      </div>
      <Spin spinning={loading}>

      <Form
        onFinish={onFinish}
        initialValues={{ degree: "0" }}
        form={form}
        onFinishFailed={onFinishFailed}
      >
        <Row style={{ marginTop: "75px" }}>
          <Col span={2}></Col>
          <Col span={20}>
            <div
              style={{
                opacity: "95%",
                backgroundColor: "#f9f9f9",
                borderRadius: "20px",
                boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                padding: "25px",
              }}
            >
              <p className="textParagraphTablet">
                شرکت ایرانیان پوشش در راستای حمایت از اندیشه های خلاق ، نیروهای
                جوان و نخبگان ، هر سال اقدام به برگزاری{" "}
                <span
                  style={{
                    fontSize: ".9em",
                    color: "#4983C4",
                    fontFamily: "IranSans",
                  }}
                >
                  <strong>جشنواره انتخاب پایان نامه برتر در حوزه بیمه</strong>
                </span>{" "}
                می کند. این جشنواره در{" "}
                <span
                  style={{
                    fontSize: ".9em",
                    color: "#4983C4",
                    fontFamily: "IranSans",
                  }}
                >
                  <strong>سیزدهم آذر</strong>
                </span>{" "}
                ، مصادف با سالروز تأسیس این شرکت و روز ملی صنعت بیمه برگزار می
                شود که طی آن پایان نامه های ارائه شده در حوزه های مختلف بیمه ای
                به داوری گذاشته می شوند.
              </p>
              <Row>
                <Col span={24} style={{ direction: "rtl", textAlign: "right" }}>
                  <Row>
                    <p className="textParagraphTablet">
                      <span
                        style={{
                          fontSize: ".9em",
                          color: "#ed1c24",
                          fontFamily: "IranSans",
                        }}
                      >
                        <strong>هدیه</strong>
                      </span>{" "}
                      پایان نامه ی برتر: جایزه نقدی + استخدام در شرکت ایرانیان
                      پوشش
                    </p>
                  </Row>
                  <Row>
                    <p className="textParagraphTablet">
                      <span
                        style={{
                          fontSize: ".9em",
                          color: "#ed1c24",
                          fontFamily: "IranSans",
                        }}
                      >
                        <strong>مهلت ارسال:</strong>
                      </span>{" "}
                      پایان آبان ماه 1399
                    </p>
                  </Row>
                </Col>
              </Row>

              <Margin top={3}></Margin>
              <Row>
                <Col span={8}>
                  <div style={{ margin: "10px" }}>
                    <Form.Item
                      name="phone"
                      rules={[
                        {
                          validator: isNumeric,
                        },
                        {
                          required: true,
                          message: "شماره موبایل را وارد نمایید",
                        },
                      ]}
                    >
                      <Input
                        style={contactInputTablet}
                        placeholder="شماره موبایل"
                      />
                    </Form.Item>
                  </div>
                </Col>
                <Col span={8}>
                  <div style={{ margin: "10px" }}>
                    <Form.Item
                      name="code"
                      rules={[
                        {
                          validator: isNumeric,
                        },
                        {
                          required: true,
                          message: "کد ملی را وارد نمایید",
                        },
                      ]}
                    >
                      <Input style={contactInputTablet} placeholder="کدملی" />
                    </Form.Item>
                  </div>
                </Col>
                <Col span={8}>
                  <div style={{ margin: "10px" }}>
                    <Form.Item
                      name="name"
                      rules={[
                        {
                          required: true,
                          message: "نام و نام خانوادگی را وارد نمایید",
                        },
                      ]}
                    >
                      <Input
                        style={contactInputTablet}
                        placeholder="نام و نام خانوادگی"
                      />
                    </Form.Item>
                  </div>
                </Col>
              </Row>
              <Margin top={3}></Margin>
              <Row>
                <Col span={8}>
                  <div style={{ margin: "10px" }}>
                  <Form.Item
                      name="birth_date"
                      rules={[
                        //     {
                        //       validator: validateEmail,
                        //     },
                        {
                          required: true,
                          message: "تاریخ تولد را وارد نمایید!",
                        },
                      ]}
                    >
                    <Input
                      style={contactInputTablet}
                      placeholder="تاریخ تولد ۱۳۹۹/۱۲/۲۴"
                    />
                    </Form.Item>
                  </div>
                </Col>
                <Col span={8}>
                  <div style={{ margin: "10px" }}>
                    <Form.Item
                      name="provience"
                      rules={[
                        {
                          required: true,
                          message: "استان محل سکونت را وارد نمایید",
                        },
                      ]}
                    >
                      <Input
                        style={contactInputTablet}
                        placeholder="استان محل سکونت"
                      />
                    </Form.Item>
                  </div>
                </Col>
                <Col span={8}>
                  <div style={{ margin: "10px" }}>
                    <Form.Item
                      name="email"
                      rules={[
                        {
                          required: true,
                          message: "پست الکترونیک را وارد نمایید",
                        },
                      ]}
                    >
                      <Input
                        style={contactInputTablet}
                        placeholder="پست الکترونیک"
                      />
                    </Form.Item>
                  </div>
                </Col>
              </Row>
              <Margin top={3}></Margin>
              <Row>
                <Col span={24}>
                  <div style={{ margin: "10px" }}>
                    <Form.Item
                      name="address"
                      rules={[
                        {
                          required: true,
                          message: "آدرس محل سکونت را وارد نمایید",
                        },
                      ]}
                    >
                      <TextArea
                        style={contactInputTablet}
                        rows={2}
                        placeholder="آدرس محل سکونت"
                      />
                    </Form.Item>
                  </div>
                </Col>
              </Row>
              <Margin top={3}></Margin>
              <Row>
                <Col span={8}>
                  <div style={{ margin: "10px", width: "100%" }}>
                    {/* <Upload style={{ width: "100%" }} {...props}>
                      <Button style={{ borderRadius: "20px", width: "175px" }}>
                        <p style={contactInput}>
                          آپلود فایل پایان نامه
                          <UploadOutlined />
                        </p>
                      </Button>
                    </Upload> */}
                    <Upload
                      fileList={fileList}
                      style={{ width: "100%" }}
                      beforeUpload={handleupload}
                    >
                      <Button style={{ borderRadius: "20px", width: "125px" }}>
                          <p style={contactInputTablet}>
                          آپلود فایل 
                          <UploadOutlined />
                        </p>
                      </Button>
                    </Upload>
                  </div>
                </Col>
                <Col span={8}>
                  <div style={{ margin: "10px" }}>
                    <Form.Item
                      name="reshte"
                      rules={[
                        {
                          required: true,
                          message: "رشته تحصیلی را انتخاب نمایید",
                        },
                      ]}
                    >
                      <Input
                        style={contactInputTablet}
                        placeholder="رشته تحصیلی"
                      />
                    </Form.Item>
                  </div>
                </Col>
                <Col span={8}>
                  <div style={{ margin: "10px" }}>
                    <Form.Item
                      name="degree"
                      rules={[
                        {
                          validator: isNumeric,
                        },
                        {
                          required: true,
                          message: "رشته تحصیلی را انتخاب نمایید",
                        },
                      ]}
                    >
                      <Select
                        className="ant-select ant-select-single ant-select-show-arrow"
                        style={contactSelect}
                        defaultValue="1"
                        onChange={handleChange}
                      >
                        <Option style={contactInputTablet} value="0" disabled>
                          آخرین مدرک تحصیلی
                        </Option>
                        <Option style={contactInputTablet} value="0">
                          کارشناسی
                        </Option>
                        <Option style={contactInputTablet} value="1">
                          کارشناسی ارشد
                        </Option>
                        <Option style={contactInputTablet} value="2">
                          دکترا
                        </Option>
                      </Select>
                    </Form.Item>
                  </div>
                </Col>
              </Row>
              <Margin top={3}></Margin>
              <Row>
                <Col span={18} style={{ direction: "ltr", textAlign: "left" }}>
                  <div style={{ margin: "10px" }}>
                    <Button
                      htmlType="submit"
                      class="introBtn introBtn-white introBtn-animated"
                      style={{
                        fontSize: ".8em", fontFamily: "IRANSans", paddingRight: "20px", paddingLeft: "20px", paddingTop: "1.5px", paddingBottom: "1.5px", backgroundColor: "#186491", color: "#fff", borderRadius: "100px"
                      }}
                    >
                      ارسال
                    </Button>
                  </div>
                </Col>
                <Col span={6}></Col>
              </Row>
            </div>
            <Margin bottom={5}></Margin>
          </Col>
          <Col span={2}></Col>
        </Row>
      </Form>
      </Spin>
    </div>
  ) : (
    <div className="FestivalBackground">
      <div style={{ paddingTop: "75px" }}>
        <Center>
              <p className="mainTitleMobile mainTitleBorderRightMobile mainTitleBorderLeftMobile" style={{ color:"#fff" }}>
            <strong>جشنواره پایان نامه ای</strong>
          </p>
        </Center>
      </div>
      <Spin spinning={loading}>

      <Form
        onFinish={onFinish}
        initialValues={{ degree: "0" }}
        form={form}
        onFinishFailed={onFinishFailed}
      >
        <Row style={{ marginTop: "50px" }}>
          <Col span={1}></Col>
          <Col span={22}>
            <div
              style={{
                opacity: "95%",
                backgroundColor: "#f9f9f9",
                borderRadius: "20px",
                boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                padding: "25px",
              }}
            >
              <p className="textParagraphMobile">
                شرکت ایرانیان پوشش در راستای حمایت از اندیشه های خلاق ، نیروهای
                جوان و نخبگان ، هر سال اقدام به برگزاری{" "}
                <span
                  style={{
                    fontSize: ".9em",
                    color: "#4983C4",
                    fontFamily: "IranSans",
                  }}
                >
                  <strong>جشنواره انتخاب پایان نامه برتر در حوزه بیمه</strong>
                </span>{" "}
                می کند. این جشنواره در{" "}
                <span
                  style={{
                    fontSize: ".9em",
                    color: "#4983C4",
                    fontFamily: "IranSans",
                  }}
                >
                  <strong>سیزدهم آذر</strong>
                </span>{" "}
                ، مصادف با سالروز تأسیس این شرکت و روز ملی صنعت بیمه برگزار می
                شود که طی آن پایان نامه های ارائه شده در حوزه های مختلف بیمه ای
                به داوری گذاشته می شوند.
              </p>
              <Row>
                <Col span={24} style={{ direction: "rtl", textAlign: "right" }}>
                  <Row>
                    <p className="textParagraphMobile">
                      <span
                        style={{
                          fontSize: ".9em",
                          color: "#ed1c24",
                          fontFamily: "IranSans",
                        }}
                      >
                        <strong>هدیه</strong>
                      </span>{" "}
                      پایان نامه ی برتر: جایزه نقدی + استخدام در شرکت ایرانیان
                      پوشش
                    </p>
                  </Row>
                  <Row>
                    <p className="textParagraphMobile">
                      <span
                        style={{
                          fontSize: ".9em",
                          color: "#ed1c24",
                          fontFamily: "IranSans",
                        }}
                      >
                        <strong>مهلت ارسال:</strong>
                      </span>{" "}
                      پایان آبان ماه 1399
                    </p>
                  </Row>
                </Col>
              </Row>

              <Margin top={3}></Margin>
              <Row>
                <Col span={24}>
                  <div style={{ margin: "10px" }}>
                    <Form.Item
                      name="name"
                      rules={[
                        {
                          required: true,
                          message: "نام و نام خانوادگی را انتخاب نمایید",
                        },
                      ]}
                    >
                      <Input
                        style={contactInputMobile}
                        placeholder="نام و نام خانوادگی"
                      />
                    </Form.Item>
                  </div>
                </Col>
                <Col span={24}>
                  <div style={{ margin: "10px" }}>
                    <Form.Item
                      name="code"
                      rules={[
                        {
                          validator: isNumeric,
                        },
                        {
                          required: true,
                          message: "کد ملی را انتخاب نمایید",
                        },
                      ]}
                    >
                      <Input style={contactInputMobile} placeholder="کدملی" />
                    </Form.Item>
                  </div>
                </Col>
                <Col span={24}>
                  <div style={{ margin: "10px" }}>
                    <Form.Item
                      name="phone"
                      rules={[
                        {
                          validator: isNumeric,
                        },
                        {
                          required: true,
                          message: "شماره موبایل را وارد نمایید",
                        },
                      ]}
                    >
                      <Input
                        style={contactInputMobile}
                        placeholder="شماره موبایل"
                      />
                    </Form.Item>
                  </div>
                </Col>
                <Col span={24}>
                  <div style={{ margin: "10px" }}>
                    <Form.Item
                      name="email"
                      rules={[
                        {
                          required: true,
                          message: "پست الکترونیک را وارد نمایید",
                        },
                      ]}
                    >
                      <Input
                        style={contactInputMobile}
                        placeholder="پست الکترونیک"
                      />
                    </Form.Item>
                  </div>
                </Col>

                <Col span={24}>
                  <div style={{ margin: "10px" }}>
                    <Form.Item
                      name="provience"
                      rules={[
                        {
                          required: true,
                          message: "استان محل سکونت را وارد نمایید",
                        },
                      ]}
                    >
                      <Input
                        style={contactInputMobile}
                        placeholder="استان محل سکونت"
                      />
                    </Form.Item>
                  </div>
                </Col>
                <Col span={24}>
                  <div style={{ margin: "10px" }}>
                  <Form.Item
                      name="birth_date"
                      rules={[
                        //     {
                        //       validator: validateEmail,
                        //     },
                        {
                          required: true,
                          message: "تاریخ تولد را وارد نمایید",
                        },
                      ]}
                    >
                    <Input
                      style={contactInputTablet}
                      placeholder="تاریخ تولد ۱۳۹۹/۱۲/۲۴"
                    />
                    </Form.Item>
                  </div>
                </Col>


                <Col span={24}>
                  <div style={{ margin: "10px" }}>
                    <Form.Item
                      name="address"
                      rules={[
                        {
                          required: true,
                          message: "آدرس محل سکونت را وارد نمایید",
                        },
                      ]}
                    >
                      <TextArea
                        style={contactInputTablet}
                        rows={2}
                        placeholder="آدرس محل سکونت"
                      />
                    </Form.Item>
                  </div>
                </Col>
                <Col span={24}>
                  <div style={{ margin: "10px" }}>
                    <Form.Item
                      name="degree"
                      rules={[
                        {
                          validator: isNumeric,
                        },
                        {
                          required: true,
                          message: "رشته تحصیلی را انتخاب نمایید",
                        },
                      ]}
                    >
                      <Select
                        className="ant-select ant-select-single ant-select-show-arrow"
                        style={contactSelectMobile}
                        defaultValue="1"
                        onChange={handleChange}
                      >
                        <Option style={contactInputMobile} value="0" disabled>
                          آخرین مدرک تحصیلی
                        </Option>
                        <Option style={contactInputMobile} value="0">
                          کارشناسی
                        </Option>
                        <Option style={contactInputMobile} value="2">
                          کارشناسی ارشد
                        </Option>
                        <Option style={contactInputMobile} value="3">
                          دکترا
                        </Option>
                      </Select>
                    </Form.Item>
                  </div>
                </Col>
                <Col span={24}>
                  <div style={{ margin: "10px" }}>
                    <Form.Item
                      name="reshte"
                      rules={[
                        {
                          required: true,
                          message: "رشته تحصیلی را انتخاب نمایید",
                        },
                      ]}
                    >
                      <Input
                        style={contactInputMobile}
                        placeholder="رشته تحصیلی"
                      />
                    </Form.Item>
                  </div>
                </Col>
                <Col span={24}>
                  <div style={{ margin: "10px" }}>
                    {/* <Upload style={{ width: "100%" }} {...props}>
                    <Button style={{ borderRadius: "20px", width: "225px" }}>
                      <p style={contactInput}>
                        آپلود فایل پایان نامه
                        <UploadOutlined />
                      </p>
                    </Button>
                  </Upload> */}
                    <Upload
                      fileList={fileList}
                      style={{ width: "100%" }}
                      beforeUpload={handleupload}
                    >
                      <Button style={{ borderRadius: "20px", width: "225px" }}>
                            <p style={contactInputMobile}>
                          آپلود فایل پایان نامه
                          <UploadOutlined />
                        </p>
                      </Button>
                    </Upload>
                  </div>
                </Col>
              </Row>
              <Margin top={3}></Margin>
              <Row>
                <Col span={18} style={{ direction: "ltr", textAlign: "left" }}>
                  <div style={{ margin: "10px" }}>
                    <Button
                      htmlType="submit"
                      class="introBtn introBtn-white introBtn-animated"
                      style={{
                        fontSize: ".75em", fontFamily: "IRANSans", paddingRight: "20px", paddingLeft: "20px", paddingTop: "1.5px", paddingBottom: "1.5px", backgroundColor: "#186491", color: "#fff", borderRadius: "100px"
                      }}
                    >
                      ارسال
                    </Button>
                  </div>
                </Col>
                <Col span={6}></Col>
              </Row>
            </div>
            <Margin bottom={4}></Margin>
          </Col>
          <Col span={1}></Col>
        </Row>
      </Form>
      </Spin>
    </div>
  );
};

export default FestivalMain;
